export const sendToGtm = (event: string, data: Record<string, any>) => {
    window.dataLayer?.push({ event, enhanced_conversion_data: data });
};
